import * as React from 'react';
import { EditOutlined } from '@ant-design/icons';
import CustomerSettingsModal from './components/Modal';

interface ICustomerSettingsProps {
  order: GQL.IOrder;
  onUpdate: (data: any) => void;
}

interface ICustomerSettingsState {
  modalOpened: boolean;
}

class CustomerSettings extends React.Component<ICustomerSettingsProps, ICustomerSettingsState> {

  constructor(props: ICustomerSettingsProps) {
    super(props);

    this.state = {
      modalOpened: false,
    };

    this.onToggleModal = this.onToggleModal.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  
  public render() {
    const { order } = this.props;

    return (
      <React.Fragment>
        <div className="editBlock customer" onClick={this.onToggleModal}>

          <div className="icon">
            <EditOutlined onClick={this.onToggleModal} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>E-mail</span>
            <b>{order.email}</b>
          </div>
          {order.companyName && (
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <span style={{ color: '#999897' }}>Company</span>
              <span>{order.companyName}
              </span>
            </div>
          )}
          {order.companyRegistrationNumber && (
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <span style={{ color: '#999897' }}>Registration ID</span>
              <span>{order.companyRegistrationNumber}</span>
            </div>
          )}
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>VAT number</span>
            <span>
              {order.companyVatNumber 
                ? order.companyVatNumber 
                : <span style={{ color: '#999897' }}>- not set -</span>}
              {order.companyVatNumberValid 
                ? <span style={{ color: "rgb(255, 25, 25)" }}> Valid!</span> 
                : ''}
            </span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>Name</span>
            <span>{order.invoiceFirstName} {order.invoiceLastName}</span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>Phone</span>
            <span>{order.phone}</span>
          </div>

        </div>

        {this.state.modalOpened &&
          <CustomerSettingsModal 
            order={order}
            onSubmit={this.onSubmit}
            onClose={this.onToggleModal}
          />}
      </React.Fragment>
    );
  }

  private onToggleModal() {
    this.setState({
      modalOpened: !this.state.modalOpened,
    });
  }

  private async onSubmit(data: any) {
    await this.props.onUpdate(data);
    this.onToggleModal();
  }
}

export default CustomerSettings;


// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/CustomerSettings/CustomerSettings.tsx